var map = {
	"./dropdown-logout.png": 37522,
	"./dropdown-logout.svg": 17531,
	"./dropdown-profile.png": 33930,
	"./dropdown-profile.svg": 22186,
	"./dropdown-security.png": 68472,
	"./dropdown-security.svg": 62216,
	"./dropdown-settings.png": 17999,
	"./dropdown-settings.svg": 54481,
	"./footer/facebook.svg": 78705,
	"./footer/instagram.svg": 88804,
	"./footer/linkedin.svg": 73071,
	"./footer/telegram.svg": 77852,
	"./footer/tiktok.svg": 44718,
	"./footer/twitter.svg": 51859,
	"./footer/youtube.svg": 12100,
	"./hataLogo.png": 16155,
	"./loading_bar.gif": 50452,
	"./loading_lines.gif": 29898,
	"./profile-icon.svg": 15563,
	"./sidebar/bell.svg": 61924,
	"./sidebar/buy_crypto.svg": 28695,
	"./sidebar/career.svg": 3276,
	"./sidebar/exchange.svg": 77375,
	"./sidebar/explore.svg": 19590,
	"./sidebar/help_centre.svg": 44822,
	"./sidebar/identification.svg": 41708,
	"./sidebar/message-question.svg": 59852,
	"./sidebar/myr.svg": 66063,
	"./sidebar/otc.svg": 94586,
	"./sidebar/profile.svg": 41811,
	"./sidebar/security.svg": 63442,
	"./sidebar/settings.svg": 86505,
	"./sidebar/usd.svg": 62687,
	"./sidebar/wallet.svg": 91408,
	"./sidebarIcon.svg": 97125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45358;